import { Stack } from "@volca/ui/components/ui/stack";
import type { IPackChatThreadSummary } from "@/payroll/pack-chat/types";
import { PackChatThreadRow } from "./pack-chat-thread-row";

export const PackChatThreadQueue = ({
  technicianName,
  threads,
  openThreadId,
  onSelectThread,
}: {
  technicianName: string | undefined;
  threads: IPackChatThreadSummary[];
  openThreadId: string | null;
  onSelectThread: (threadId: string) => void;
}) => (
  <Stack
    gap={0}
    align="stretch"
    className="min-h-0 min-w-0 md:border-r md:border-line"
  >
    <div className="h-full min-h-0 overflow-y-auto">
      {/* Named, because on its own a column of figures beside a column of
          people does not say whose questions these are. */}
      <Stack
        align="start"
        gap={0}
        role="group"
        aria-label={`Questions from ${technicianName ?? "this technician"}`}
        className="w-full min-w-0 divide-y divide-line pb-5"
      >
        {threads.map((thread) => (
          <PackChatThreadRow
            key={thread.id}
            thread={thread}
            selected={thread.id === openThreadId}
            onSelect={() => onSelectThread(thread.id)}
          />
        ))}
      </Stack>
    </div>
  </Stack>
);
